<template>
  <vx-card :title="'Données de l\'analyse du keyword: ' + serpData.keyword">
    <span
      >Moteur de recherche utilisé pour la recherche:
      <span class="fw-bold">{{ serpData.searchEngine }}</span></span
    >
    <br />
    <span
      >Localisation de la recherche:
      <span class="fw-bold">{{ serpData.region.name }}</span>
    </span>
    <vs-table
      max-items="10"
      pagination
      stripe
      :data="serpData.data.organic"
      class="mt-4"
    >
      <template slot="thead">
        <vs-th>Url</vs-th>
        <vs-th><span class="w-full">Domaine</span></vs-th>
        <vs-th><span class="txt_align_right w-full">Position</span></vs-th>
        <vs-th><span class="txt_align_right w-full">Page</span></vs-th>
        <vs-th><span class="w-full">Titre</span></vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :key="index"
          v-for="(row, index) in data"
          :style="[
            row.url.includes(urlReducer(society.gsc_url))
              ? { 'background-color': '#35e9fd !important' }
              : { background: 'transparent!important' }
          ]"
        >
          <vs-td class="max-w-2/5"
            ><span class="url_box">{{ decodeURI(row.url) }}</span></vs-td
          >
          <vs-td class="fw-bold">{{ row.domain }}</vs-td>
          <vs-td class="txt_align_right">{{ row.position }}</vs-td>
          <vs-td class="txt_align_right min-w-1/4">{{ row.page }}</vs-td>
          <vs-td>{{ row.title }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "SerpTable",
	props: {
		serpData: Array,
		society: Object
	},
	mixins: [utilsMixin]
};
</script>

<style scoped>
.txt_align_right {
  text-align: right;
}

.url_box {
  word-break: break-word;
}
.fw-bold {
  font-weight: bold;
}
</style>
